<div class="card-row">
  <div class="left">
    <img src="../../../../../assets/images/xpm-logo.svg" alt="img" class="img-max36">
    <div class="text-container">
      <div class="text">XPM</div>
      <div class="sub-text">{{ getLastSyncDateMessage() }}</div>
    </div>
  </div>

  <div class="right">
    <div
      ngbDropdown
      [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
      class="right d-inline-flex"
    >
      <button
        ngbDropdownToggle
        class="btn btn-secondary btn-icon"
        [disabled]="disableControls"
      >
        <i class="icon ic-more-horizontal-20"></i>
      </button>

      <div
        ngbDropdownMenu
        aria-labelledby="company-actions-dd"
        class="common-dropdown-menu dropdown-menu dropdown-menu-right"
      >
        @for (item of xpmMenu; track $index) {
          @if (item?.isVisable()) {
            <button ngbDropdownItem (click)="item.action()">
              <i class="{{item.iconClass}}"></i>
              <span>{{ item.title }}</span>
            </button>
          }
        }
      </div>
    </div>
  </div>
</div>
